const asArray = value => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

const normalize = value => String(value).trim().toLowerCase().replace(/[-\s]+/g, '_');

export const MASTER_ADMIN_EMAIL = 'info@custodiy.com';

export const getSessionIdentity = session => (
  session?.data?.user || session?.user || session || null
);

export const getSessionRoles = (session) => {
  const identity = getSessionIdentity(session);
  return asArray(identity?.roles || identity?.role || session?.roles || session?.role)
    .map(normalize);
};

export const getSessionPermissions = (session) => {
  const identity = getSessionIdentity(session);
  return asArray(
    identity?.permissions
    || identity?.permission
    || session?.permissions
    || session?.permission,
  ).map(normalize);
};

export const isMasterAdministrator = session => (
  String(getSessionIdentity(session)?.email || '').trim().toLowerCase() === MASTER_ADMIN_EMAIL
);

export const canAccess = ({ session, allowedRoles, requiredPermissions }) => {
  const expectedRoles = asArray(allowedRoles).map(normalize);
  const expectedPermissions = asArray(requiredPermissions).map(normalize);
  const roles = getSessionRoles(session);
  const permissions = getSessionPermissions(session);

  const roleAllowed = expectedRoles.length === 0
    || expectedRoles.some(role => roles.includes(role));
  const permissionsAllowed = expectedPermissions.length === 0
    || expectedPermissions.every(permission => permissions.includes(permission));

  return roleAllowed && permissionsAllowed;
};
